<script>
 import Dropdown from './Dropdown.svelte';
 import { restapi } from './store.js';
 import { mockHttpRequest } from './localCalibre.js';

 export let mock;

 let candidates = [];
 let secondClick = false;
 let selection = "";
 let selectedCandidate = document.getElementById("selectedCandidate");
 let showCandiList = false;
 let candiv;

 let candidateSets = {
     'authors': new Set(),
     'titles': new Set(),
     'tags': new Set()
 }

 // Search mode Dropdown defaults and exports
 let searchModeDefault = "authors";
 let searchModeList = ["titles", "tags"];
 let searchModeListTotal = [searchModeDefault].concat(searchModeList);
 let searchMode = searchModeDefault;

 // when search mode changes, update corresponding lists
 $: {
     if (searchMode != searchModeDefault) {
         searchModeDefault = searchMode;
         searchModeList = [];
         searchModeListTotal.forEach(el => {
             if (el !== searchModeDefault) {
                 searchModeList.push(el)
             }
         });
         candidates = [...Array.from(candidateSets[searchModeDefault])]
         reset("")
     }
 }

 const cssCandidate = "pl-2 text-lg";
 const cssSelectedCandidate = "pl-2 border-b-2 border-motw-red italic font-bold";

 $: filteredCandidates = candidates.filter(
     item => item.toLowerCase().indexOf(selection.toLowerCase()) !== -1
 )

 $: fetchCompletion(selection)

 async function fetchCompletion(selection) {
     var sel = selection.toLowerCase();
     var url = `${$restapi}autocomplete/${searchMode}/${sel}`;
     candidates = [...Array.from(candidateSets[searchMode])]
     if (selection.length !== 4) {
         return
     }
     if (mock) {
         var _ = mockHttpRequest(CALIBRE_BOOKS1.books, url, 48)
     } else {
         const res = await fetch(url);
         var _ = await res.json();
     }
     _._items.forEach(i => candidateSets[searchMode].add(i))
     var sorted = [...Array.from(candidateSets[searchMode])].sort()
     candidates = sorted;
     if (candidates.length > 0) {
         filteredCandidates = candidates.filter(
             item => item.toLowerCase().indexOf(selection.toLowerCase()) !== -1
         )
     }

 }

 function search(e) {
     location.hash = `#/search/${searchMode}/${selection}`;
 }

 function setSelectedCandidate(elem) {
     if (elem) {
         var mdl = " modulo1";
         if (elem.className.includes("modulo0")) {
             elem.style.backgroundColor = "#e7e7e7"
             mdl = " modulo0";
         } else {
             elem.style.backgroundColor = "#ffffff"
         }
         elem.className = cssSelectedCandidate + mdl;
         elem.id = "selectedCandidate";
     }
 }

 function resetSelectedCandidate(elem) {
     if (elem) {
         var mdl = " modulo1";
         if (elem.className.includes("modulo0")) {
             elem.style.backgroundColor = "#e7e7e7"
             mdl = " modulo0";
         } else {
             elem.style.backgroundColor = "#ffffff"
         }
         elem.className = cssCandidate + mdl;
         elem.id = "";
     }
 }

 function onKeyUp(event) {
     if (["ArrowLeft", "ArrowRight", "Backspace", "Delete"].includes(event.key)) {
         reset(selection);
     }

     selectedCandidate = document.getElementById("selectedCandidate");
     if (event.key == "Enter") {
         // selectItemCloseDropdown(selectedCandidate);
         if (selectedCandidate) {
             selection = selectedCandidate.innerText.toLowerCase();
         }
         location.hash = `#/search/${searchMode}/${selection.toLowerCase()}`
         reset(selection)
         return;
     } else if (event.key == "Escape") {
         reset("");
         return;
     }
     if (filteredCandidates && (event.key == "ArrowDown" || selection.length > 0)) {
         showCandiList = true;
     }

     if (["ArrowDown", "ArrowUp"].includes(event.key)) {
         if (!selectedCandidate) {
             /* candiv = document.getElementById("candilist") */
             setSelectedCandidate(candiv.firstChild);
             return;
         }
         resetSelectedCandidate(selectedCandidate);
         if (event.key == "ArrowDown") {
             if (selectedCandidate.nextSibling) {
                 setSelectedCandidate(selectedCandidate.nextSibling);
             } else {
                 setSelectedCandidate(candiv.firstChild);
                 selectedCandidate = document.getElementById("selectedCandidate");
             }
         } else {
             if (selectedCandidate.previousSibling) {
                 setSelectedCandidate(selectedCandidate.previousSibling);
             } else {
                 setSelectedCandidate(candiv.lastChild);
                 selectedCandidate = document.getElementById("selectedCandidate");
             }
         }
         window.scroll(0, 0)
         selectedCandidate.scrollIntoView({
             behavior: "smooth",
             block: "center"
         });
     }
 }

 function expandOnClick(event) {
     if (secondClick && selection.length == 0) {
         showCandiList = true;
         secondClick = false;
     } else {
         reset(selection);
         secondClick = true;
     }
 }

 function reset(e) {
     if (candiv) {
         candiv.scroll(0, 0);
     }
     secondClick = false;
     selectedCandidate = document.getElementById("selectedCandidate");
     resetSelectedCandidate(selectedCandidate);
     selectedCandidate = false;
     if (typeof e === 'string') {
         selection = e;
     }
     if (showCandiList) {
         showCandiList = false;
     }
 }

 function highlightCandidate(event) {
     setSelectedCandidate(event.target);
 }
 
 function dimlightCandidate(event) {
     resetSelectedCandidate(event.target);
 }
 

 /*
  * Call to complete item selection in dropdown, e.g. on item selection with
  * keyboard or when focus is lost on input. If dropdown is visible then hide
  *  it. Also, if selection is made, propagate it with selection variable.
  */
 function selectItemCloseDropdown(e) {
     if (showCandiList) {
         showCandiList = false;
     }
     selectedCandidate = document.getElementById("selectedCandidate");
     if (selectedCandidate) {
         selection = selectedCandidate.innerText.toLowerCase();
         location.hash = `#/search/${searchMode}/${selection.toLowerCase()}`
         reset(selection)
     }

 }

</script>

<style>
 .candilist {
     max-height: 16em;
 }

 .showCandidates {
     @apply block border-motw-red border-b-4;
 }

 .zeroBottomBorder {
     @apply border-b-0;
 }

 .modulo1 {
     @apply bg-white;
 }

 .modulo0 {
     background-color: #e7e7e7;
 }
</style>

<div class="inline-flex w-full">
    <Dropdown bind:selectedItem={searchMode} defaultItem={searchModeDefault} droplist={searchModeList} />
    <div class="relative w-full">
        <input class="monocle:text-sm phone:text-sm appearance-none mt-3 border-b-4 border-motw-red focus:outline-none w-full pl-2 text-lg" class:zeroBottomBorder={showCandiList} type="text" aria-label="Search" placeholder="Search" bind:value="{selection}" on:click={expandOnClick} on:keyup={onKeyUp} on:focusout={selectItemCloseDropdown} />

        <ul id="candidateList" bind:this={candiv} class="candilist hidden cursor-pointer absolute z-50 w-full text-lg overflow-y-auto" class:showCandidates={showCandiList}>
            {#each filteredCandidates as candidate, i}
                <li on:mouseover={highlightCandidate} on:mouseout={dimlightCandidate} class="{cssCandidate} modulo{i%2}">{candidate}</li>
            {/each}
        </ul>
    </div>
    <button on:click="{search}" class="monocle:hidden phone:hidden bg-motw-red active:text-red-200 focus:outline-none text-white p-2 font-bold text-lg hover:underline" type="button" name="B">SEARCH</button>
    <div class="bg-motw-red phablet:hidden p-1" on:click={search}>
        <svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" class="object-scaled-down" clip-rule="evenodd" stroke="none" stroke-width="0" fill="white" width="24px" height="24px"><path d="M21.172 24l-7.387-7.387c-1.388.874-3.024 1.387-4.785 1.387-4.971 0-9-4.029-9-9s4.029-9 9-9 9 4.029 9 9c0 1.761-.514 3.398-1.387 4.785l7.387 7.387-2.828 2.828zm-12.172-8c3.859 0 7-3.14 7-7s-3.141-7-7-7-7 3.14-7 7 3.141 7 7 7zm-3-8c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"/></svg>
    </div>
</div>
